import { Col, Row } from "./Flexbox";
import Text from "./Text";

const ConfirmationWindow = ({theme, message, action, params, btnText, onClose}) => {

    const handleAction = () => {
        if (params !== undefined && params !== null) {
            action(params);
        } else {
            action();
        }
    }

    const isDark = theme.White !== "#FFFFFF";
    return (
        <div style={{position: 'fixed', top:0, left:0, right:0, bottom:0, background: 'rgba(0, 0, 0, 0.5)', alignItems: 'center', display: 'flex', justifyContent: 'center', zIndex: 1000, boxSizing: 'border-box'}}>
            <Col style={{width:'100%', height: '100%', maxWidth: '450px', maxHeight: '250px', flex:'none', alignItems:'flex-start', paddingLeft: 32, paddingRight: 32, paddingTop: 32, paddingBottom: 32, marginTop: 32, backgroundColor: theme.White,  borderRadius: 4, boxShadow: isDark ? '0px 10px 40px rgba(0, 0, 0, 0.8)' : '0px 10px 30px rgba(0, 0, 0, 0.1)'}}>
                <Col style={{width: '100%', justifyContent: 'start', paddingTop: 12, gap: 16, alignItems: 'start'}}>
                    <Text size={17} color={theme.ONED}>{message}</Text>
                    <Text color={theme.SEVENB}>Esta acción no se puede deshacer</Text>
                </Col>
                <Row style={{width: '100%', justifyContent: 'space-between', paddingTop: 40, gap: 16}}>
                    <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} onClick={onClose} color={theme.Lao} size={15}>Cancelar</Text>
                    <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} onClick={handleAction} color={theme.Magenta} size={15}>{btnText}</Text>
                </Row>
            </Col>
        </div>
    )
}

export default ConfirmationWindow;